import { createSlice } from '@reduxjs/toolkit';
import { UserUserinfoListApiResponse } from '@ports/internal-services/user/userSlice';
import type { RootState } from './store';

export type authStateType = {
  userData: UserUserinfoListApiResponse;
  isFindAMatchPermission: boolean;
  isAllOptionManualMatch: boolean;
};

const initialState: authStateType = {
  userData: {} as UserUserinfoListApiResponse,
  isFindAMatchPermission: false,
  isAllOptionManualMatch: false
};

export const userStateSlice = createSlice({
  name: 'userStateSlice',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setFindAMatchPermission: (state, action) => {
      state.isFindAMatchPermission = action.payload;
    },
    setAllOptionManualMatch: (state, action) => {
      state.isAllOptionManualMatch = action.payload;
    },
    resetUserData: () => {
      return initialState;
    }
  }
});

export const {
  setUserData,
  setAllOptionManualMatch,
  setFindAMatchPermission,
  resetUserData
} = userStateSlice.actions;
export const getUserData = (state: RootState) => state.userStateSlice?.userData;
export const getIsFindAMatchPermission = (state: RootState) =>
  state.userStateSlice?.isFindAMatchPermission;
export const getIsAllOptionManualMatch = (state: RootState) =>
  state.userStateSlice?.isAllOptionManualMatch;
